import { createContext } from 'react';

const ScrollContext = createContext<React.MutableRefObject<HTMLDivElement> | null>(null);

export default ScrollContext;
